import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/pages/LandingPage";
import BrowseTradies from "@/pages/BrowseTradies";
import TradieProfile from "@/pages/TradieProfile";
import GetQuote from "@/pages/GetQuote";
import TradieSignup from "@/pages/TradieSignup";
import AdminPanel from "@/pages/AdminPanel";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import CookiePolicy from "@/pages/CookiePolicy";
import LocationPage from "@/pages/LocationPage";
import ServicePage from "@/pages/ServicePage";
import BuyCredits from "@/pages/BuyCredits";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Pricing from "@/pages/Pricing";
import { Toaster } from "@/components/ui/sonner";

// Australian Hotspots Directory Pages
import { HotspotsHome, CityPage, CategoryPage, BusinessPage, AdvertisePage, ListBusinessPage } from "@/pages/hotspots";

// My Boy Lollipop - AI Male Model Subscription Landing
import MyBoyLollipop from "@/pages/MyBoyLollipop";
import LollipopAdmin from "@/pages/LollipopAdmin";

// SEO Furnace - Mass Page Generator
import SEOFurnace from "@/pages/SEOFurnace";

// Coffee On The Go - Mobile Coffee Van
import CoffeeOnTheGo from "@/pages/CoffeeOnTheGo";
import CoffeeOnTheGoAdmin from "@/pages/CoffeeOnTheGoAdmin";

// Kata AI Search Concierge
import KataChat from "@/components/KataChat";

// Wrapper to conditionally show Kata on Hotspots pages
const KataWrapper = () => {
  const location = useLocation();
  const isHotspotsPage = location.pathname.startsWith('/hotspots');
  return isHotspotsPage ? <KataChat /> : null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/browse" element={<BrowseTradies />} />
            {/* SEO-friendly tradie URLs */}
            <Route path="/tradies/:location/:service/:slug" element={<TradieProfile />} />
            {/* Legacy UUID URLs - still supported */}
            <Route path="/tradie/:id" element={<TradieProfile />} />
            <Route path="/get-quote" element={<GetQuote />} />
            <Route path="/join" element={<TradieSignup />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/buy-credits" element={<BuyCredits />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            {/* Service Index Page - e.g., /services/electrician */}
            <Route path="/services/:serviceSlug" element={<ServicePage />} />
            {/* SEO Location Pages - e.g., /electrician/gold-coast */}
            <Route path="/:serviceSlug/:locationSlug" element={<LocationPage />} />
            
            {/* ========== AUSTRALIAN HOTSPOTS DIRECTORY ========== */}
            <Route path="/hotspots" element={<HotspotsHome />} />
            <Route path="/hotspots/advertise" element={<AdvertisePage />} />
            <Route path="/hotspots/list-business" element={<ListBusinessPage />} />
            <Route path="/hotspots/:cityId" element={<CityPage />} />
            <Route path="/hotspots/:cityId/:categorySlug" element={<CategoryPage />} />
            <Route path="/hotspots/:cityId/:categorySlug/:subLocation" element={<CategoryPage />} />
            {/* SEO-friendly business URLs */}
            <Route path="/hotspots/:cityId/:categorySlug/business/:slug" element={<BusinessPage />} />
            {/* Legacy UUID URLs - still supported */}
            <Route path="/hotspots/business/:businessId" element={<BusinessPage />} />
            <Route path="/hotspots/category/:categorySlug" element={<CategoryPage />} />
            
            {/* ========== MY BOY LOLLIPOP - AI MODEL SITE ========== */}
            <Route path="/myboylollipop" element={<MyBoyLollipop />} />
            <Route path="/lollipop" element={<MyBoyLollipop />} />
            <Route path="/lollipop/admin" element={<LollipopAdmin />} />
            
            {/* ========== SEO FURNACE - MASS PAGE GENERATOR ========== */}
            <Route path="/seofurnace" element={<SEOFurnace />} />
            <Route path="/furnace" element={<SEOFurnace />} />
            
            {/* ========== COFFEE ON THE GO - MOBILE COFFEE VAN ========== */}
            <Route path="/coffeeonthego" element={<CoffeeOnTheGo />} />
            <Route path="/coffeeonthego/admin" element={<CoffeeOnTheGoAdmin />} />
          </Routes>
          {/* Kata AI Chat - Hotspots Pages Only */}
          <KataWrapper />
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;